import React from 'react';
import { BAND_TONE } from '../../lib/leiConditions';

/**
 * Navigation Health Ribbon (Rec 2) — replaces the isolated gauge.
 * Shows the 5 Missing Middle condition stages derived from the LEI
 * pillars (no new math, just regrouping) with descriptive bands.
 */
export function NavigationConditionsRibbon({ conditions }) {
  if (!conditions?.length) return null;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="navigation-conditions-ribbon">
      <p className="text-[11px] font-bold uppercase tracking-widest text-slate-500 mb-3">Navigation Health Ribbon</p>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {conditions.map((c) => (
          <div
            key={c.key}
            data-testid={`condition-tile-${c.key}`}
            className="rounded-lg bg-slate-50 border border-slate-200 px-3 py-2.5"
            title={c.pillarName ? `${c.label} stage · ${c.pillarShortName} (LEI pillar)` : c.label}
          >
            <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">{c.label}</p>
            <div className="flex items-baseline gap-2">
              <p className="text-2xl font-extrabold tabular-nums leading-tight text-slate-900">
                {c.score != null ? Math.round(c.score) : '—'}
              </p>
              <span className={`rounded-full border px-2 py-0.5 text-[10px] font-bold ${BAND_TONE[c.band.tone]}`}>
                {c.band.label}
              </span>
            </div>
            <div className="h-1.5 mt-1.5 rounded-full bg-slate-200/70 overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{ width: `${Math.min(100, Math.max(0, c.score ?? 0))}%`, backgroundColor: c.color }}
              />
            </div>
            <p className="text-[10px] mt-1 text-slate-400 truncate">{c.pillarShortName}</p>
          </div>
        ))}
      </div>
      <p className="mt-3 text-[11px] text-slate-400">
        Derived from your existing LEI pillars — same scores, regrouped into Missing Middle condition stages.
      </p>
    </div>
  );
}
